import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UiPageLoading } from "~/components/elements";
import { PAGE_URLS } from "~/constants";
import { useAppDispatch, useNotification } from "~/hooks";
import { logout } from "~/redux/auth/thunk";

function LogoutPage() {
  const dispatch = useAppDispatch();
  const { addMessage } = useNotification(dispatch);
  const history = useHistory();

  useEffect(() => {
    const runAsync = async () => {
      await dispatch(logout());
      history.replace(PAGE_URLS.LOGIN);
    };
    runAsync();
  }, [dispatch, history]);

  return <UiPageLoading />;
}

export default LogoutPage;
